import { ConstructorInterfaceActionJwtDecode } from '../../../../../interface.type'
export default function DecodeJwtActionInterface({ action }: {
    action: ConstructorInterfaceActionJwtDecode
}) {

    return <div className='ActionInterface'>
        Decodifique en JWT
    </div>

}